export const _DOCUMENT_ =
  typeof document !== "undefined" ? document : ({} as Document);
export const _WINDOW_ = typeof window !== "undefined" ? window : ({} as Window);
export const _HEAD_ = (_DOCUMENT_ && _DOCUMENT_.head) || ({} as HTMLHeadElement);
